import { Badge, Dropdown } from "react-bootstrap";
import { getJeepRallyMediaUrl } from "../../../../../../api/jeep-rally/api";
import { getCategoryRouteSummary } from "../../utils/category.utils";

const CategoryImage = ({ category }) => {
  const imageUrl = getJeepRallyMediaUrl(category?.image);

  if (!imageUrl) {
    return (
      <div
        className="d-flex align-items-center justify-content-center bg-light text-muted"
        style={{
          width: "56px",
          height: "40px",
          borderRadius: "6px",
          border: "1px solid #dee2e6",
          fontSize: "10px",
        }}
      >
        No image
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={category?.title || "Category"}
      style={{
        width: "56px",
        height: "40px",
        objectFit: "cover",
        borderRadius: "6px",
        border: "1px solid #dee2e6",
      }}
    />
  );
};

const CategoriesTable = ({
  categories,
  onEdit,
  onDelete,
  isDeleting,
  canManage,
}) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>Image</th>
            <th>Title</th>
            <th>Key</th>
            <th>Route</th>
            <th>Max Members</th>
            <th>Navigator</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((category, index) => {
            const categoryId = category._id || category.id;

            return (
              <tr key={categoryId || `${category.key}-${index}`}>
                <td>{index + 1}</td>
                <td>
                  <CategoryImage category={category} />
                </td>
                <td>{category.title || "-"}</td>
                <td>
                  <Badge bg="secondary">{category.key || "-"}</Badge>
                </td>
                <td>{getCategoryRouteSummary(category)}</td>
                <td>{category.max_members ?? "-"}</td>
                <td>{category.navigator_allowed ? "Yes" : "No"}</td>
                <td>{category.description || "-"}</td>
                <td className="text-center">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="link"
                      className="p-0 text-decoration-none"
                    >
                      &#x2022;&#x2022;&#x2022;
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <Dropdown.Item
                        onClick={() => onEdit(category)}
                        disabled={!categoryId || !canManage}
                      >
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => onDelete(category)}
                        className="text-danger"
                        disabled={!categoryId || isDeleting || !canManage}
                      >
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CategoriesTable;
